<div class="modal-dialog" role="document">
  <div class="modal-content h-100 bg-white">
    <div class="modal-header">
      <button type="button" (click)="createActivity('XX');" class="close menuItemsClrBlack" data-dismiss="modal"
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <h5 class="modal-title cursorArrow">{{ 'notification.notify' | translate }}</h5>
    </div>
    <div class="modal-body notify-modal-body-height cursorArrow">
      <div class="row h-100 bg-white pt-0 pr-0 overflowYTextAuto">
        <div id="notificationArrayList">No notifications to display.</div>
        <div class="row pt-0 pm-0">
          <div class="col-6 col-xs-6">
            <nav>
              <ul class="pagination floatleft">
                <li class="page-item" [ngClass]="{ dis: skipNotifyCount<=0 }">
                  <a class="page-link" tabindex="-1" (click)="getAllNotifications(skipNotifyCount-10,'')">
                    <<{{ 'notification.prev' | translate }}</a>
                </li>
              </ul>
            </nav>
          </div>
          <div class="col-6 col-xs-6">
            <nav>
              <ul class="pagination floatright">
                <li class="page-item" [ngClass]="{ dis: skipNotifyCount+10 >= maxNotifyCount }">
                  <a class="page-link" (click)="getAllNotifications(skipNotifyCount+10,'')">
                    {{ 'notification.next' | translate }}>>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>